<form #form="ngForm" (ngSubmit)="onSubmit(form)">
  <mat-card class="mat-elevation-z0" style="margin-top: 20px">
    <div class="form-title">
      <div class="form-title-text">Bedrijf</div>
    </div>
    <div
      class="company-form-container"
      *ngFor="let projectContact of projectContacts; let i = index"
    >
      <div class="form-line">
        <ng-container
          *ngIf="
            !client || adminCreate || inputProject.id != null;
            else clientCompanyPicker
          "
        >
          <company-picker
            class="first-form-field form-field"
            [company]="projectContact.company"
            [canEdit]="true"
            [client]="client && !adminCreate"
            [disabled]="
              client &&
              inputProject.id != null &&
              inputProject.subProjects[0]?.status !== STATUS.DRAFT.valueOf()
            "
            (companyIsSelected)="selectCompany($event, i)"
          >
          </company-picker>
        </ng-container>
        <ng-template #clientCompanyPicker>
          <client-company-picker
            class="first-form-field form-field"
            (companyIsSelected)="selectCompany($event, i)"
          ></client-company-picker>
        </ng-template>
        <div class="form-field">
          <select-autocomplete
            name="contact{{ i }}"
            [label]="'Contactpersoon'"
            [placeholder]="'Contactpersoon'"
            [options]="companyContacts[i]"
            [filterFunction]="filterContact"
            [displayOption]="displayContact"
            [disabled]="
              client &&
              inputProject.id != null &&
              inputProject.subProjects[0]?.status !== STATUS.DRAFT.valueOf()
            "
            [(ngModel)]="projectContact.contact"
            (ngModelChange)="contactChange($event, i)"
            required
          ></select-autocomplete>
        </div>
        <div
          *ngIf="!client && projectContact.contact?.archived"
          class="translate-warning-icon"
          [matTooltip]="
            'Deze contactpersoon is verwijderd, gelieve een andere te selecteren'
          "
        >
          <mat-icon>report_problem</mat-icon>
        </div>

        <mat-form-field
          class="form-field"
          [ngClass]="showCloseButton(projectContact) ? 'shorter-field' : ''"
          appearance="outline"
        >
          <mat-label>Telefoonnummer Contact</mat-label>
          <input
            name="phoneCompany{{ i }}"
            matInput
            placeholder="Telefoonnummer"
            value="{{ projectContact.contact.phoneNumberDisplay }}"
            disabled
          />
        </mat-form-field>

        <mat-form-field
          class="form-field"
          [ngClass]="showCloseButton(projectContact) ? 'shorter-field' : ''"
          appearance="outline"
        >
          <mat-label>GSM-nummer Contact</mat-label>
          <input
            name="phoneContact{{ i }}"
            matInput
            placeholder="Telefoonnummer"
            value="{{ projectContact.contact.mobileNumberDisplay }}"
            disabled
          />
        </mat-form-field>
        <mat-form-field class="last-form-field form-field" appearance="outline">
          <mat-label>E-mailadres</mat-label>
          <input
            [(ngModel)]="
              projectContact.contact.emails[0] &&
              projectContact.contact.emails[0].email
            "
            name="emailContact{{ i }}"
            matInput
            placeholder="E-mailadres"
            disabled
          />
        </mat-form-field>
        <div class="button-middle">
          <button
            *ngIf="!projectContact.contact.id || projectContacts.length <= 2"
            mat-icon-button
            class="bg-transparent transparent"
            disabled
          >
            <mat-icon> close</mat-icon>
          </button>
          <button
            *ngIf="projectContact.contact.id && projectContacts.length > 2"
            mat-icon-button
            aria-label="Verwijder bedrijf"
            (click)="deleteProjectContact(projectContact)"
          >
            <mat-icon svgIcon="close"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <checkbox
      *ngIf="!client"
      [text]="'Er zijn meerdere partijen betrokken bij dit project'"
      [isDisabled]="isMultiplePartiesDisabled"
      [checked]="multipleParties"
      (answer)="multipleCompaniesChecked($event, true)"
    >
    </checkbox>
    <div *ngIf="client" class="upper-space">
      <ng-container *ngIf="newClientProject">
        <div class="d-flex">
          <div class="other-contact-selector">
            <div class="form-sub-title">
              Kies meerdere contactpersonen binnen het bedrijf
            </div>

            <mat-form-field class="" appearance="outline">
              <mat-select
                matInput
                multiple
                placeholder="Optioneel"
                [(ngModel)]="selectedOtherContacts"
                [panelClass]="'wider-panel'"
                name="otherContactSelector"
                (ngModelChange)="otherContactsChange()"
                [compareWith]="compareEntities"
              >
                <mat-option
                  *ngFor="let option of otherContactOptions"
                  [value]="option"
                >
                  {{
                    option.firstName
                      | personName : option.lastName
                      | joiner
                        : ' - '
                        : option.phoneNumberDisplay
                        : option.mobileNumberDisplay
                        : option.emails[0]?.email
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="selectedOtherContacts?.length > 0" class="left-space">
            <div class="form-sub-title">Gekozen contactpersonen</div>
            <ul class="inpress-ul">
              <li
                *ngFor="
                  let otherContact of selectedOtherContacts;
                  trackBy: trackById
                "
              >
                {{
                  otherContact.firstName
                    | personName : otherContact.lastName
                    | joiner
                      : ' - '
                      : otherContact.phoneNumberDisplay
                      : otherContact.mobileNumberDisplay
                      : otherContact.emails[0]?.email
                }}
              </li>
            </ul>
          </div>
        </div>
        <yes-no
          [value]="inputProject.collaborative"
          [yesValue]="'Gezamenlijke opdracht (met meerdere makelaars)'"
          [noValue]="'Individuele opdracht'"
          [neverShowExtraInstructions]="true"
          [flexRow]="false"
          [yesFirst]="false"
          (answer)="collaborativeChange($event)"
        ></yes-no>
        <div
          *ngIf="inputProject.collaborative"
          class="extra-company-contact-picker-margin"
        >
          <extra-company-contact-picker
            [project]="inputProject"
            [disabled]="!client && !adminCreate"
          ></extra-company-contact-picker>
        </div>
      </ng-container>
    </div>

    <div *ngIf="projectContacts.length > 1">
      <div class="form-title">
        <div class="form-title-text">Project verantwoordelijke</div>
      </div>
      <ng-template>Bedrijf</ng-template>
      <div class="form-line">
        <mat-form-field
          class="first-form-field form-field"
          appearance="outline"
        >
          <mat-label>Contactpersoon</mat-label>
          <mat-select
            name="contactPM"
            matInput
            placeholder="Contactpersoon"
            [(ngModel)]="projectManager"
            [disabled]="
              client &&
              inputProject.id != null &&
              inputProject.subProjects[0]?.status !== STATUS.DRAFT.valueOf()
            "
            required
            (selectionChange)="selectProjectManager($event)"
          >
            <mat-option
              *ngFor="
                let projectContact of projectContacts | noEmptyProjectContacts
              "
              [value]="projectContact"
            >
              {{ projectContact.contact.firstName }}
              {{ projectContact.contact.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="form-field form-field" appearance="outline">
          <mat-label>Bedrijf</mat-label>
          <mat-select
            name="companyPM"
            matInput
            placeholder="Bedrijf"
            required
            [(ngModel)]="projectManager"
            [disabled]="true"
            (selectionChange)="selectProjectManager($event)"
          >
            <mat-option
              *ngFor="
                let projectContact of projectContacts | noEmptyProjectContacts
              "
              [value]="projectContact"
            >
              {{ projectContact.company.regularName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Telefoonnummer bedrijf</mat-label>
          <input
            name="phoneCompanyPM"
            matInput
            placeholder="Telefoonnummer bedrijf"
            value="{{
              projectManager &&
                projectManager.company.telephones[0] &&
                formatPhoneNumber.transform(
                  projectManager.company.telephones[0].number
                )
            }}"
            [disabled]="true"
          />
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Telefoonnummer contact</mat-label>
          <input
            name="phoneContactPM"
            matInput
            placeholder="Telefoonnummer contact"
            value="{{
              projectManager &&
                projectManager.contact.telephones[0] &&
                formatPhoneNumber.transform(
                  projectManager.contact.telephones[0].number
                )
            }}"
            [disabled]="true"
          />
        </mat-form-field>
        <mat-form-field class="last-form-field form-field" appearance="outline">
          <mat-label>E-mailadres</mat-label>
          <input
            name="emailCompanyPM"
            matInput
            placeholder="E-mailadres"
            [(ngModel)]="
              projectManager &&
              projectManager.contact.emails[0] &&
              projectManager.contact.emails[0].email
            "
            [disabled]="true"
          />
        </mat-form-field>
      </div>
    </div>
    <ng-container
      *ngIf="!client && !fromOldSystem && inputProject.collaborative"
    >
      <div class="upper-space">
        <div *ngIf="inputProject.otherCompanies?.length > 0">
          <!-- support legacy otherCompanies field -->
          <div class="strong">Info gezamenlijk project</div>
          <div class="upper-space preserve-line-break">
            {{ inputProject.otherCompanies }}
          </div>
        </div>
        <extra-company-contact-picker
          [project]="inputProject"
          [disabled]="true"
        ></extra-company-contact-picker>
      </div>
    </ng-container>
  </mat-card>

  <div class="flexer text-right">
    <button class="button" type="submit" mat-button (click)="nextPart()">
      Volgende
    </button>
  </div>
</form>
